import { render, staticRenderFns } from "./numberCardModal.vue?vue&type=template&id=06f28912&scoped=true&"
import script from "./numberCardModal.vue?vue&type=script&lang=js&"
export * from "./numberCardModal.vue?vue&type=script&lang=js&"
import style0 from "./numberCardModal.vue?vue&type=style&index=0&id=06f28912&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f28912",
  null
  
)

export default component.exports